import FeedbackQuestions from "../../../../contents/docs/cdp/_snippets/feedback-questions.mdx";
import PostHogMaintained from "../../../../contents/docs/cdp/_snippets/posthog-maintained.mdx";
import { CalloutBox } from 'components/Docs/CalloutBox';
import * as React from 'react';
export default {
  FeedbackQuestions,
  PostHogMaintained,
  CalloutBox,
  React
};